/**
 * 前端访问数据上报工具
 *
 * 功能：
 * 1. 生成并持久化匿名访客 ID（UUID v4，存储在 localStorage）
 * 2. 每次页面切换时向自建后端 POST 上报访问记录
 *
 * 与 GA4 的关系：
 * - GA4 负责基础用户行为分析（跳出率、会话时长等）
 * - 本模块负责向自建后端上报核心指标（IP、页面路径、语言等）
 */
import { axiosRequest } from '@/utils/request.js'

/**
 * 获取或生成匿名访客 ID（存储在 localStorage 中）
 * 格式为标准 UUID v4，首次生成后缓存到 localStorage
 * @returns {string} 访客唯一标识
 */
function getVisitorId () {
  const key = 'yoox_visitor_id'
  let id = localStorage.getItem(key)
  if (!id) {
    // 生成 UUID v4 格式的匿名 ID
    id = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      const r = (Math.random() * 16) | 0
      const v = c === 'x' ? r : (r & 0x3) | 0x8
      return v.toString(16)
    })
    localStorage.setItem(key, id)
  }
  return id
}

/**
 * 上报页面访问到自建后端
 * 后端会根据请求 IP 自动解析地理位置，并进行 30 秒内同 IP 同页面防刷
 *
 * @param {string} pagePath  - 页面路径（如 /en/blog/1-xxx）
 * @param {string} pageTitle - 页面标题（来自 document.title）
 * @param {string} lang      - 当前语言代码（如 en、zh）
 */
export function reportVisit (pagePath, pageTitle, lang) {
  try {
    axiosRequest({
      method: 'POST',
      url: '/public/visit',
      data: {
        visitorId: getVisitorId(),
        pagePath: pagePath || '/',
        pageTitle: pageTitle || document.title,
        referer: document.referrer || '',
        lang: lang || '',
      },
    })
  } catch (_e) {
    // 上报失败不影响用户体验，静默忽略
  }
}
